<template>
  <v-container fluid>
    <v-row justify="center" class="ma-0">
      <list-news/>
    </v-row>
  </v-container>
</template>

<script>
// import NewsCreate from "../../components/AdminOnly/NewsCreate"
import ListNews from "../../components/AdminOnly/ListNews"

export default {
  name: "News",
  components: {
    ListNews
  },
  created() {
    this.$appMng.setTitle("Listagem de novidade")
    if (!this.$store.state.user.userData.blAllowAdmin) {
      this.$router.push('/401')
    }
  }
}
</script>

<style scoped>

</style>